export default {
  math: {
    /**
     * @desc 解决浮动运算问题，避免小数点后产生多位数和计算精度损失。
     * 问题示例：2.3 + 2.4 = 4.699999999999999，1.0 - 0.9 = 0.09999999999999998
     */
    /**
     * 把错误的数据转正
     * strip(0.09999999999999998)=0.1
     */
    strip(num, precision) {
      if (precision === void 0) { precision = 15; }
      return +parseFloat(Number(num).toPrecision(precision));
    },
    /**
     * Return digits length of a number
     * @param {*number} num Input number
     */
    digitLength(num) {
      // Get digit length of e
      let eSplit = num.toString().split(/[eE]/);
      let len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
      return len > 0 ? len : 0;
    },
    /**
     * 把小数转成整数，支持科学计数法。如果是小数则放大成整数
     * @param {*number} num 输入数
     */
    float2Fixed(num) {
      if (num.toString().indexOf('e') === -1) {
        return Number(num.toString().replace('.', ''));
      }
      let dLen = this.digitLength(num);
      return dLen > 0 ? this.strip(Number(num) * Math.pow(10, dLen)) : Number(num);
    },

    /**
     * 精确乘法
     */
    times(num1, num2) {
      let num1Changed = this.float2Fixed(num1);
      let num2Changed = this.float2Fixed(num2);
      let baseNum = this.digitLength(num1) + this.digitLength(num2);
      let leftValue = num1Changed * num2Changed;
      return leftValue / Math.pow(10, baseNum);
    },
    /**
     * 精确加法
     */
    plus(num1, num2) {
      let baseNum = Math.pow(10, Math.max(this.digitLength(num1), this.digitLength(num2)));
      return (this.times(num1, baseNum) + this.times(num2, baseNum)) / baseNum;
    },

    /**
     * 精确减法
     */
    minus(num1, num2) {
      let baseNum = Math.pow(10, Math.max(this.digitLength(num1), this.digitLength(num2)));
      return (this.times(num1, baseNum) - this.times(num2, baseNum)) / baseNum;
    },
    /**
     * 精确除法
     */
    divide(num1, num2) {
      let num1Changed = this.float2Fixed(num1);
      let num2Changed = this.float2Fixed(num2);

      // fix: 类似 10 ** -4 为 0.00009999999999999999，strip 修正
      return this.times(num1Changed / num2Changed, this.strip(Math.pow(10, this.digitLength(num2) - this.digitLength(num1))));
    },

    /**
     * 四舍五入
     */
    round(num, ratio) {
      let base = Math.pow(10, ratio);
      return this.divide(Math.round(this.times(num, base)), base);
    },
  },
  /**
   * 加法
   */
  plus: function (num1, num2, len) {
    num1 = this.clearNumberChar(num1);
    num2 = this.clearNumberChar(num2);
    let num = this.math.plus(num1, num2);
    if (!len && 0 != len) return num;
    return this.math.round(num,len);
  },
  /**
   * 减法
   */
  minus: function (num1, num2, len) {
    num1 = this.clearNumberChar(num1);
    num2 = this.clearNumberChar(num2);
    let num = this.math.minus(num1, num2);
    if (!len && 0 != len) return num;
    return this.math.round(num,len);
  },
  /**
   * 乘法
   */
  times: function (num1, num2, len) {
    num1 = this.clearNumberChar(num1);
    num2 = this.clearNumberChar(num2);
    let num = this.math.times(num1,num2);
    if (!len && 0 != len) return num;
    return this.math.round(num,len);
  },
  /**
   * 除法
   */
  divide: function(num1, num2, len) {
    num1 = this.clearNumberChar(num1);
    num2 = this.clearNumberChar(num2);
    let num = this.math.divide(num1,num2);
    if (!len && 0 != len) return num;
    return this.math.round(num,len);
  },
  round: function(num, ratio) {
    num = this.clearNumberChar(num);
    return this.math.round(num, ratio);
  },
  clearNumberChar(str) {

    if (!str) return 0;
    if (typeof(str) != 'string') return str;
    // 去空格
    str = str.replace(/\s+/g,"")
    if (!str) return 0;
    if (str.indexOf(",")>0) {
      str = str.replace(",","");
    }
    if (str.indexOf(".")>0){
      return parseFloat(str);
    }
    return parseInt(str);
  },
  /***********************************************************
   *  function    : precise
   *  des         : 两个数加减乘除
   *  args        :
   *      arg1
   *      arg2
   *      opt     : 可以接受的参数为“+”、“-”、“*”、“/”
   *      arg3    : 计算结果的小数位
   ***********************************************************/
  precise(arg1,arg2,opt,arg3){
    if (opt=="+"){
      return parseFloat(this.plus(arg1,arg2,arg3))
    } else if (opt=="-"){
      return parseFloat(this.minus(arg1,arg2,arg3))
    } else if (opt=="*"){
      return parseFloat(this.times(arg1,arg2,arg3))
    } else if (opt=="/"){
      return parseFloat(this.divide(arg1,arg2,arg3))
    }
  },
}

